// Shared sport identifiers (align with `environment.sport_id` / tenant build):
// | sport_id | Sport        |
// |----------|--------------|
// | 1        | Table tennis |
// | 2        | Padel        |
// | 3        | Tennis       |
// | 4        | Badminton    |
export enum SportId {
  TableTennis = 1,
  Padel = 2,
  Tennis = 3,
  Badminton = 4,
}

